import Button from '~/src/common/components/Button';
import Icon from '~/src/common/components/Icon';
import I18n from '~/src/common/services/I18n';

import * as S from './layout';

interface Props {
  onClickRetry: () => unknown;
}

const ErrorSmall = ({ onClickRetry }: Props) => (
  <S.ErrorSmallContainer>
    <div>
      <Icon name="warning-normal" />
      <p>{I18n.t('category.error.small.text')}</p>
    </div>
    <Button onClick={() => void onClickRetry()}>{I18n.t('category.error.small.btn')}</Button>
  </S.ErrorSmallContainer>
);

export default ErrorSmall;
